import { ALLOWED_MEDIA } from '@/app/components/media/app-image';
import type { ResponsiveImageSource } from '@/app/components/media/app-image/responsive-image/types';
import type { SizesString } from '@/app/components/media/app-image/shared/image-size-types';
import type {
  AppVideoPoster,
  AppVideoSrc,
} from '@/app/components/media/app-video';
import type { SpartanProductFeatureMedia } from '@/app/lcv/components/sections/spartan/products/shared/feature-carousel/types';

export const SPARTAN_PRODUCT_FEATURE_CAROUSEL_IMAGE_CLASS_NAME =
  'relative aspect-1-1 w-full overflow-hidden md:aspect-16-9';

export const SPARTAN_PRODUCT_FEATURE_CAROUSEL_MAIN_SIZES =
  '(min-width: 1280px) 1176px, (min-width: 768px) calc(100vw - 80px), calc(100vw - 32px)' as const satisfies SizesString;

export const SPARTAN_PRODUCT_FEATURE_CAROUSEL_THUMBNAIL_SIZES =
  '(min-width: 768px) 128px, 72px' as const satisfies SizesString;

export const getSpartanProductFeatureMobileImageSource = (
  image: SpartanProductFeatureMedia,
  sizes: SizesString = SPARTAN_PRODUCT_FEATURE_CAROUSEL_MAIN_SIZES
): ResponsiveImageSource => ({
  src: image.mobile.src,
  media: ALLOWED_MEDIA.mdDown,
  sizes,
  widths:
    sizes === SPARTAN_PRODUCT_FEATURE_CAROUSEL_THUMBNAIL_SIZES
      ? [256]
      : [640, 750, 828, 1080, 1280, 1440, 1680],
  params:
    sizes === SPARTAN_PRODUCT_FEATURE_CAROUSEL_THUMBNAIL_SIZES
      ? { ar: '1-1', f: 'auto' }
      : { f: 'auto' },
});

export const getSpartanProductFeatureDesktopImageSource = (
  image: SpartanProductFeatureMedia,
  sizes: SizesString = SPARTAN_PRODUCT_FEATURE_CAROUSEL_MAIN_SIZES
): ResponsiveImageSource => ({
  src: image.desktop.src,
  media: ALLOWED_MEDIA.mdUp,
  sizes,
  widths:
    sizes === SPARTAN_PRODUCT_FEATURE_CAROUSEL_THUMBNAIL_SIZES
      ? [256]
      : [1440, 1680, 1920, 2048, 2560],
  params:
    sizes === SPARTAN_PRODUCT_FEATURE_CAROUSEL_THUMBNAIL_SIZES
      ? { ar: '16-9', f: 'auto' }
      : { f: 'auto' },
});

export const getSpartanProductFeatureVideoPoster = (
  image: SpartanProductFeatureMedia,
  alt: string
): AppVideoPoster => ({
  alt,
  mobileSrc: getSpartanProductFeatureMobileImageSource(image),
  desktopSrc: getSpartanProductFeatureDesktopImageSource(image),
});

export const getSpartanProductFeatureVideoSource = (
  video: SpartanProductFeatureMedia
): string | AppVideoSrc => {
  if (video.mobile.src === video.desktop.src) return video.desktop.src;

  return {
    mobile: video.mobile.src,
    desktop: video.desktop.src,
  };
};
